import {
  type AdvancePaymentDomainSelectModel,
  AdvancePaymentId,
  AdvancePaymentStatuses,
  AgreementId,
  ProjectId,
  UserId,
} from '@mntn-dev/domain-types'
import { getRandomItem } from '@mntn-dev/utilities'

import { MockModel } from './mock-model.ts'

export const MockAdvancePayment = MockModel<AdvancePaymentDomainSelectModel>(
  ({
    advancePaymentId = AdvancePaymentId(),
    projectId = ProjectId(),
    status = getRandomItem(AdvancePaymentStatuses),
    isStatusAlertDismissed = false,
    request = {
      actorId: UserId(),
      timestamp: new Date(),
      amount: 10000 * 10,
      amountPercent: 50,
      previousAdvancePaymentsAmount: 0,
      cumulativeAmountPercent: 50,
      fee: 500,
      neededByDate: new Date(),
      reason: 'Show me the money!',
      agreements: [AgreementId()],
    },
  }) => {
    return {
      advancePaymentId,
      projectId,
      status,
      isStatusAlertDismissed,
      request,
    } satisfies AdvancePaymentDomainSelectModel
  }
)
